import { AutoComplete } from '@grapecity/wijmo.react.input';
import React from 'react';

class AutoCompleteComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || '',
      selectedItem: null, // 初期選択アイテム
    };
  }

  _onTextChanged = (sender, e) => {
    const newValue = sender.text;
    this.setState({ value: newValue });
    // itemsSource内に存在するか確認
    const selectedItem = this.props.itemsSource.find((item) => item.value === newValue);
    if (selectedItem) {
      // // itemsSource内に存在する場合、選択
      this.setState({ selectedItem: selectedItem });
      this.props.onChange(sender.inputElement, { key: selectedItem.key, value: newValue });
    } else {
      // itemsSource内に存在しない場合、自由入力値を設定
      this.setState({ selectedItem: null });
      this.props.onChange(sender.inputElement, { key: 0, value: newValue });
    }
  };

  _onInitialized = (sender) => {
    // itemsSource内に存在するか確認
    const selectedItem = this.props.itemsSource.find((item) => item.key === this.state.value);
    if (selectedItem) {
      // itemsSource内に存在する場合、初期選択
      this.setState({ selectedItem: selectedItem });
      sender.selectedItem = selectedItem;
    } else {
      // itemsSource内に存在しない場合、自由入力値を表示
      sender.text = this.state.value;
    }
  };

  render() {
    return (
      <AutoComplete
        value={this.state.value}
        displayMemberPath={this.props.displayMemberPath}
        itemsSource={this.props.itemsSource}
        textChanged={this._onTextChanged}
        initialized={this._onInitialized}
        selectedItem={this.state.selectedItem}
        style={{
          backgroundColor: this.props.error ? 'lightpink' : '',
        }}
      />
    );
  }
}

export default AutoCompleteComponent;
